module.exports = __webpack_public_path__ + "static/media/snow_specification_en.9bbfd533.md";